import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LazyImage } from '@/components/common';
import DetailBlock from './DetailBlock';
import { pageTo } from '@/utils/comment';
export default {
  name: 'detail-video-photo',
  components: {
    LazyImage: LazyImage,
    DetailBlock: DetailBlock
  },
  props: {
    videoStageName: String,
    // 视频剧照组件标题
    photoNum: Number,
    // 剧照总数量
    videoList: {
      // 视频list
      type: Array,
      default: function _default() {
        return [];
      }
    },
    photoStageList: {
      // 剧照list
      type: Array,
      default: function _default() {
        return [];
      }
    },
    performanceId: Number,
    // 项目ID
    isCategory: Boolean
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // 先注册滚动事件
            _this.$refs.box.addEventListener('scroll', _this.scroll, false);
            _context.next = 3;
            return _this.getPhotoPreview();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    // 跳转至剧照页
    goToPhoto: function goToPhoto() {
      this.$emit('gotoMoreStats');
      pageTo("/photo/".concat(this.performanceId));
      // this.$router.push( `/photo/${this.performanceId}` )
    },

    // 跳转至视频页
    goToVideo: function goToVideo(e) {
      // 获取视频id
      var vid = e.currentTarget.dataset.vid;
      this.$emit('previewStats');
      pageTo("/video-page/".concat(this.performanceId, "/").concat(vid));
      // this.$router.push( `/video-page/${this.performanceId}/${vid}` )
    },

    // 刷新剧照预览，避免无法打开预览插件
    getPhotoPreview: function getPhotoPreview() {
      this.$previewRefresh();
    },
    photoPreViewStats: function photoPreViewStats() {
      this.$emit('previewStats');
    }
  }
};